import { ACCESS_TOKEN_KEY } from "@iso/constants/common.constant";
import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

export default class RakutenScoringSettingService extends BaseService {
  search = (params) => {
    const searchParams = new URLSearchParams();
    Object.keys(params || {}).forEach((key) => {
      const value = params[key];
      if (value === null || value === undefined || value === "") {
        return;
      }
      if (Array.isArray(value)) {
        if (value.length === 0) {
          return;
        }
        value.forEach((item) => {
          if (item !== null && item !== undefined && item !== "") {
            searchParams.append(key, item);
          }
        });
        return;
      }
      searchParams.append(key, value);
    });
    return this.axios.get(API_ENDPOINTS.RAKUTEN_SCORING_SETTINGS_SEARCH, {
      params: searchParams,
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
      },
    });
  };

  delete = ({ batchCrawlSettingId }) =>
    this.axios.delete(
      API_ENDPOINTS.RAKUTEN_SCORING_SETTINGS_DELETE.replace(
        "{batchCrawlSettingId}",
        batchCrawlSettingId
      )
    );

  create = (data) => {
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("isActive", data.isActive);
    formData.append("executionType", data.executionType);
    if (data.executionDay) {
      formData.append("executionDay", data.executionDay);
    }
    if (data.s3Path) {
      formData.append("s3Path", data.s3Path);
    }
    return this.axios.post(API_ENDPOINTS.RAKUTEN_SCORING_SETTINGS_CREATE, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
      },
    });
  };

  getDetail = (batchCrawlSettingId) =>
    this.axios.get(
      API_ENDPOINTS.RAKUTEN_SCORING_SETTINGS_DETAIL.replace(
        "{batchCrawlSettingId}",
        batchCrawlSettingId
      )
    );

  update = (batchCrawlSettingId, data) => {
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("isActive", data.isActive);
    formData.append("executionType", data.executionType);
    if (data.executionDay) {
      formData.append("executionDay", data.executionDay);
    }
    if (data.s3Path) {
      formData.append("s3Path", data.s3Path);
    }
    return this.axios.post(
      API_ENDPOINTS.RAKUTEN_SCORING_SETTINGS_UPDATE.replace(
        "{batchCrawlSettingId}",
        batchCrawlSettingId
      ),
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
        },
      }
    );
  };

  execute = (batchCrawlSettingId) =>
    this.axios.post(
      API_ENDPOINTS.RAKUTEN_SCORING_SETTINGS_EXECUTE.replace(
        "{batchCrawlSettingId}",
        batchCrawlSettingId
      )
    );

  cancel = (batchCrawlSettingId) =>
    this.axios.post(
      API_ENDPOINTS.RAKUTEN_SCORING_SETTINGS_CANCEL.replace(
        "{batchCrawlSettingId}",
        batchCrawlSettingId
      )
    );

  getCurrent = (batchCrawlSettingId) =>
    this.axios.get(
      API_ENDPOINTS.RAKUTEN_SCORING_SETTINGS_CURRENT.replace(
        "{batchCrawlSettingId}",
        batchCrawlSettingId
      )
    );

  getHistories = (batchCrawlSettingId) =>
    this.axios.get(
      API_ENDPOINTS.RAKUTEN_SCORING_SETTINGS_HISTORIES.replace(
        "{batchCrawlSettingId}",
        batchCrawlSettingId
      )
    );
}
